import { render } from "./PaperTradingSettings.vue?vue&type=template&id=14a6a8bc&scoped=true"
import script from "./PaperTradingSettings.vue?vue&type=script&lang=js"
export * from "./PaperTradingSettings.vue?vue&type=script&lang=js"

import "./PaperTradingSettings.vue?vue&type=style&index=0&id=14a6a8bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a6a8bc"]])

export default __exports__